module.exports = __webpack_public_path__ + "static/media/toldos-y-persianas.9a436afa.png";